import { render, staticRenderFns } from "./nuestrotrabajo-detalle.vue?vue&type=template&id=24e6532c"
import script from "./nuestrotrabajo-detalle.vue?vue&type=script&lang=js"
export * from "./nuestrotrabajo-detalle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports